// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"bb5ed8fd","471":"e33c63b1","501":"2e942b0d"}[chunkId] + ".chunk.js";
};